const STORAGE_KEYS = {
  DASHBOARD_CONFIGURATION: 'dashboard-configuration',
  DASHBOARD_ACTIVE_TAB: 'dashboard-active-tab',
  DASHBOARD_TAB_VISIBILITY: 'dashboard-tab-visibility',
  FLOW: 'flow',
  FLOW_SCHEMA: 'flow-schema-visible',
  // A new key on purpose. The old `language` slot holds a bare locale written
  // before organizations had one, and reading it now would read as a deliberate
  // pin — silently opting every existing user out of following their
  // organization, which nobody asked for.
  LANGUAGE_PREFERENCE: 'language-preference',
  ORGANIZATION: 'organization',
  PROJECT: 'project',
};

export default STORAGE_KEYS;
